import { Component, Input, OnInit, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { ConstantsService } from '../../services/constants.service';
import { BrowserPlatformService } from '../../services/browser-platform.service';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent implements OnInit, OnChanges {
  @Input() siteBrand = "";
  @Input() isPc: boolean = false;
  bannerText = "";
  constructor(public constantsService: ConstantsService, private readonly browser: BrowserPlatformService) {
    this.bannerText = this.constantsService.BANNER_DEVICE_COMPATIBILITY
   }

  ngOnInit(): void {
    if (this.browser.location.pathname.includes("audiologistInvite")) {  // For the download page
      this.bannerText = this.constantsService.BANNER_DOWNLOAD_PAGE
    }
  }

  ngOnChanges(): void {
    if (this.browser.location.pathname.includes("audiologistInvite") ||
        this.browser.location.pathname.includes("downloadpage")) {
      this.bannerText = this.constantsService.BANNER_DOWNLOAD_PAGE
    }
    else if (this.isPc) {
      this.bannerText = this.constantsService.BANNER_COMPUTER_SUPPORT
    }
    else {
      this.bannerText = this.constantsService.BANNER_DEVICE_COMPATIBILITY
    }
  }
}
